'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.19.2@axios/lib/cancel/isCancel.js
// module id = 32
// module chunks = 18